import {
  DEFAULT_ESCAPE_ACCOUNT_SETTINGS,
  ESCAPE_ACCOUNT_FIELD_KEYS,
  pickEscapeAccountFields,
} from './escapeAccountSettings';

export function pickSharedFromEscapeFlat(flat) {
  const shared = { ...flat };
  ESCAPE_ACCOUNT_FIELD_KEYS.forEach((key) => {
    delete shared[key];
  });
  delete shared.direction;
  return shared;
}

export function buildEscapeDefaultFlat() {
  return {
    ...DEFAULT_ESCAPE_ACCOUNT_SETTINGS,
    program_variant: 'oneway',
    entry_mode: 'kinpoint',
    entry_candle: '15m',
    entry_checking: -1,
    sensitivity: 2,
    atr_period: 2,
    sensitivity_short: 2,
    atr_period_short: 2,
    candle_type_entry: 'haikin',
    entry_standard: 'disable',
    ema_standard: 200,
    ema_losscut: 'no',
    candle_standard: '4h',
    candle_type_standard: 'haikin',
    sensitivity_standard: 2,
    atr_period_standard: 2,
    standard_checking: -1,
    entry_standard_2nd: 'disable',
    ema_standard_2nd: 200,
    candle_standard_2nd: '4h',
    candle_type_standard_2nd: 'haikin',
    sensitivity_standard_2nd: 2,
    atr_period_standard_2nd: 2,
    escape_mode: 'off',
    escape_auto_refresh_gap_pct: 0,
    escape_hedge_losscut_pct: 0,
    hedge_hold_ratio: 0,
    hedge_hold_mode: 'disable',
    hedge_hold_roi_pct: 0,
    hedge_hold_switch_pct: 0,
    escape_same_bar_entry_extra: 2,
    escape_first_entry_mode: 'immediate',
    plus_entry_mode: 'trigger',
    escape_entry_kp_mode: 'confirm',
    escape_exit_kp_mode: 'confirm',
    escape_swing_entry_kp_mode: 'confirm',
    escape_swing_exit_kp_mode: 'confirm',
    plus_close_kp_mode: 'trigger',
    close_candle: '15m',
    close_checking: -1,
    candle_type_close: 'haikin',
    both_mode: 'single',
    direction: 'long',
    total_benefit_start: 0,
    total_benefit_usdt: 0,
    total_benefit_usdt_obj: 0,
    total_benefit_count: 0,
    total_current_count: 0,
    total_continue_mode: 'disable',
    total_continue_direction: 'both',
    dual_open_both_at_start: 1,
    dual_trigger_min_profit_pct: 5,
    dual_trigger_candle: '1h',
    dual_trigger_candle_type: 'haikin',
    grid_line_count: 5,
    grid_gap_pct: 1,
    grid_usdt_per_line: 10,
    grid_escape_min_profit_pct: 0,
    grid_escape_apply: 'apply',
    grid_setting_mode: 'uniform',
    grid_usdt_2: 10,
    grid_usdt_3: 10,
    grid_usdt_4: 10,
    grid_usdt_5: 10,
    grid_usdt_6: 10,
    grid_gap_1: 1,
    grid_gap_2: 1,
    grid_gap_3: 1,
    grid_gap_4: 1,
    grid_gap_5: 1,
  };
}

export function resolveOnewayEscapeModeForSave({ program_variant, direction, escape_mode }) {
  if (program_variant === 'dual_regression' || program_variant === 'grid_escape') {
    return 'off';
  }
  if (escape_mode && escape_mode !== 'off') {
    return escape_mode;
  }
  if (program_variant === 'oneway' || program_variant === 'plus') {
    return 'off';
  }
  return 'off';
}

/** GET /escape/settings 응답 → 폼 flat (program_variant 등 mode 필드 포함) */
export function buildEscapeFlatFromSettingsSplit(split) {
  if (!split?.ok) {
    return null;
  }
  const row = split.main_row && typeof split.main_row === 'object' ? split.main_row : {};
  const mode = split.mode && typeof split.mode === 'object' ? split.mode : {};
  const bothMode = split.both_mode ?? mode.both_mode ?? row.both_mode ?? 'single';
  const direction =
    bothMode === 'double'
      ? row.direction ?? split.main?.direction ?? 'long'
      : split.direction ?? mode.direction ?? row.direction ?? 'long';

  return {
    ...buildEscapeDefaultFlat(),
    ...split.shared,
    ...split.main,
    ...mode,
    program_variant: split.program_variant ?? mode.program_variant ?? row.program_variant ?? 'oneway',
    both_mode: bothMode,
    direction,
  };
}

export function buildEscapeSplitPayload(flat, { both_mode, direction }) {
  const entryCandle = flat.entry_candle || '15m';
  const resolvedCloseCandle =
    flat.program_variant === 'plus' ? entryCandle : (flat.close_candle || entryCandle);
  const effectiveBothMode =
    flat.program_variant === 'dual_regression' || flat.program_variant === 'grid_escape'
      ? 'single'
      : both_mode;
  let mainDirection =
    flat.program_variant === 'dual_regression'
      ? 'both'
      : effectiveBothMode === 'double'
        ? 'long'
        : direction;
  if (flat.program_variant === 'grid_escape') {
    const d = typeof mainDirection === 'string' ? mainDirection.trim().toLowerCase() : '';
    if (d === 'short') mainDirection = 'short';
    else if (d === 'both') mainDirection = 'both';
    else mainDirection = 'long';
  }
  const auxDirection = both_mode === 'double' ? 'short' : direction;
  const accountFields = pickEscapeAccountFields(flat);
  const body = {
    ...flat,
    entry_candle: entryCandle,
    close_candle: resolvedCloseCandle,
    entry_standard_2nd: 'disable',
    direction: mainDirection,
    escape_mode: resolveOnewayEscapeModeForSave({ ...flat, direction: mainDirection }),
  };
  const shared = pickSharedFromEscapeFlat(body);
  return {
    symbol: undefined,
    shared,
    main: { ...accountFields, direction: mainDirection },
    aux: { ...accountFields, direction: auxDirection },
    both_mode: effectiveBothMode,
    direction: mainDirection,
  };
}
